export const createRule = "_Ma";
export default {createRule};